import React from "react";
import "./AboutUs.css";
import Header from "./Header";
import Whybarsana from "./Whybarsana";
import ParkedVillasSection from "./ParkedVillasSection";

import CurvedVillasSection from "./CurvedVillasSection";
import PoolVillasSection from "./PoolVillasSection";
import Footer from "./Footer";
import LatestProperties from "./LatestProperties";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

const AboutUs = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: -50 });
    }
  }, [inView, controls]);

  return (
    <>
      <Header />
   
      <Whybarsana />
      {/* <ParkedVillasSection />
      <CurvedVillasSection />
      <PoolVillasSection /> */}
      {/* <LatestProperties /> */}
      <Footer />
    </>
  );
};

export default AboutUs;
